'use strict';

angular.module('ringbaPortal.services').factory('tagService', tagService);

function tagService(
  _,
  $http,
  comparisonTypeService,
  ngAuthSettings,
  geoStatesService
) {
  'ngInject';

  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  const orFilter = {
    'tagId': '',
    'tagIds': [''],
    'comparisonType': comparisonTypeService.defaultComparisonType.key,
    'comparisonTypeTemp': comparisonTypeService.defaultComparisonType,
    'value': ''
  };
  const USStatesList = geoStatesService.getUSStates();
  const canadianProvincesList = geoStatesService.getCanadianProvinces();
  const memoizedStateNameSearch = _.memoize(function findState(stateValue) {
    return _.find(USStatesList, function (stateObj) {
      return stateObj['abbreviation'] === stateValue;
    }).name;
  });
  const memoizedProvinceNameSearch = _.memoize(function findState(provinceValue) {
    return _.find(canadianProvincesList, function (provinceObj) {
      return provinceObj['abbreviation'] === provinceValue;
    }).name;
  });
  const inComparisonType = 'IN';

  const geoTagsIds = [
    {
      tagId: 'Geo:SubDivision',
      stateValueProperty: 'name'
    },
    {
      tagId: 'Geo:SubDivisionCode',
      stateValueProperty: 'abbreviation'
    },
    {
      tagId: 'InboundNumber:State',
      stateValueProperty: 'abbreviation'
    },
    {
      tagId: 'Address:State',
      stateValueProperty: 'abbreviation'
    },
    {
      tagId: 'Lookup:gatherState',
      stateValueProperty: 'abbreviation'
    },
    {
      tagId: 'Lookup:geoState',
      stateValueProperty: 'abbreviation'
    },
    {
      tagId: 'Lookup:icpState',
      stateValueProperty: 'abbreviation'
    },
    {
      tagId: 'Lookup:userState',
      stateValueProperty: 'abbreviation'
    }
  ];

  const geoProvincesTagsIds = [
    {
      tagId: 'InboundNumber:Province',
      provinceValueProperty: 'name'
    },
    {
      tagId: 'InboundNumber:ProvinceCode',
      provinceValueProperty: 'abbreviation'
    }
  ];

  const service = {
    getTags: getTags,
    getNumberTags: getNumberTags,
    getGeoTags: getGeoTags,
    getProvinceGeoTags: getProvinceGeoTags,
    isGeoTag: isGeoTag,
    isStateGeoTag: isStateGeoTag,
    isProvinceGeoTag: isProvinceGeoTag,
    isOldProvinceTag: isOldProvinceTag,
    getGeoValue: getGeoValue,
    doesHaveMultipleValues: doesHaveMultipleValues,
    getStateValueProperty: getStateValueProperty,
    getProvinceValueProperty: getProvinceValueProperty,
    groupByGeoTags: groupByGeoTags,
    normalizeGeoAndBulkTagsInCriterias: normalizeGeoAndBulkTagsInCriterias,
    getDefaultTag: getDefaultTag,
    groupGeoTags: groupGeoTags,
    normalizeGeoTagsInAndObj: normalizeGeoTagsInAndObj,
    getTagsByCampaign: getTagsByCampaign,
    allowBulkTagsUpload: allowBulkTagsUpload,
    normalizeBulkTagForUI: normalizeBulkTagForUI,
    filterByTagSource: filterByTagSource,
    filterByTagNames: filterByTagNames,
    pushDedupTag: pushDedupTag,
    isTagInArray: isTagInArray,
    areEqualTags: areEqualTags,
    getTagSources: getTagSources,
    getShareableTags: getShareableTags
  };
  return service;

  function getTags(accountId) {
    const url = serviceBaseUri + accountId + '/tags/full';
    return $http.get(url);
  }

  function getNumberTags(accountId) {
    return getTags(accountId).then(function (response) {
      if (!response || !response.data)
        return null;

      return _.filter(response.data, function (tag) {
        return tag && tag.tagType && tag.tagType == 'DialedNumber';
      });
    });
  }

  function getTagsByCampaign(accountId, campaignId) {
    const url = serviceBaseUri + accountId + '/campaigns/' + campaignId + '/tags';
    return $http.get(url);
  }

  function getGeoTags(tagCriteria) {
    return _.filter(tagCriteria, function (tag) {
      return isGeoTag(tag.tagId, tag.tagIds);
    });
  }

  function getProvinceGeoTags(tagCriteria) {
    return _.filter(tagCriteria, function (tag) {
      return isProvinceGeoTag(tag.tagId, tag.tagIds);
    });
  }

  function isGeoTag(tagId, tagIds) {
    return isStateGeoTag(tagId, tagIds) || isProvinceGeoTag(tagId, tagIds);
  }

  function isStateGeoTag(tagId, tagIds) {
    let tag;
    if (tagId) {
      tag = _findStateGeoTag(tagId);
    } else {
      if (tagIds) {
        tag = _.find(tagIds, function (tag) {
          return _findStateGeoTag(tag);
        });
      }
    }
    return !!tag;
  }

  function isProvinceGeoTag(tagId, tagIds) {
    let tag;
    if (tagId) {
      tag = _findProvinceGeoTag(tagId);
    } else {
      if (tagIds) {
        tag = _.find(tagIds, function (tag) {
          return _findProvinceGeoTag(tag);
        });
      }
    }
    return !!tag;
  }

  function isOldProvinceTag(criteria) {
    // Check if the comparison type is a valid geo criteria
    // If it's not this was created before the new province tag model
    const geoCriteria = _.find(comparisonTypeService.comparisonTypes, function (tag) {
      return tag.forGeoTags
        && (tag.value == criteria.comparisonTypeTemp.value
          || tag.value == criteria.comparisonTypeTemp.key
          || tag.value == criteria.comparisonTypeTemp);
    });
    return !geoCriteria && criteria.oldComparisonTypeValue == undefined;
  }

  function allowBulkTagsUpload(tagId, tagIds) {
    if (tagId) {
      return _allowBulkTagsUpload(tagId);
    }

    if (tagIds) {
      const tag = _.find(tagIds, function (tagId) {
        if (!_allowBulkTagsUpload(tagId)) {
          return true;
        }
      });

      return _allowBulkTagsUpload(tag);
    }
  }

  function getGeoValue(tagId, tagIds, geoValue) {
    if (isStateGeoTag(tagId, tagIds)) {
      return getStateValue(tagId, tagIds, geoValue);
    } else {
      return getProvinceValue(tagId, tagIds, geoValue);
    }
  }

  function getStateValue(tagId, tagIds, stateValue) {
    if (getStateValueProperty(tagId, tagIds) === 'abbreviation') {
      return memoizedStateNameSearch(stateValue);
    }
    return stateValue;
  }

  function getProvinceValue(tagId, tagIds, provinceValue) {
    if (getProvinceValueProperty(tagId, tagIds) === 'abbreviation') {
      return memoizedProvinceNameSearch(provinceValue);
    }
    return provinceValue;
  }

  function getStateValueProperty(tagId, tagIds) {
    if (tagId) {
      return _getStateValueProperty(tagId);
    }

    if (tagIds) {
      const geoTag = _.find(tagIds, function (tag) {
        return isStateGeoTag(tag);
      });

      if (geoTag) {
        return _getStateValueProperty(geoTag);
      }
    }
  }

  function getProvinceValueProperty(tagId, tagIds) {
    if (tagId) {
      return _getProvinceValueProperty(tagId);
    }

    if (tagIds) {
      const geoTag = _.find(tagIds, function (tag) {
        return isProvinceGeoTag(tag);
      });

      if (geoTag) {
        return _getProvinceValueProperty(geoTag);
      }
    }
  }

  function getTagSources(tags) {
    if (tags && tags.length) {
      return _.sortBy(
        _.uniqBy(
          _.map(tags, function (tag) {
            return { id: tag.tagSource.toLowerCase(), sourceName: tag.tagSource };
          }
          ), 'id'
        ), 'id');
    }
    return [];
  }

  function getShareableTags(shareableTagSetting, availableTags) {
    const tagTypes = _getTagsWithCategory(availableTags);
    const currentShareableTagSetting = shareableTagSetting || { macroTagstoShare: [] };
    currentShareableTagSetting.macroTagstoShare = tagTypes.filter((tag) => tag.checked && tag.tagName).map((tag) => { return tag.tagType + ':' + tag.tagName; });

    return currentShareableTagSetting;
  }

  function groupByGeoTags(tagCriteria) {
    // We group the ORs criteira by the tagId, the criteria and isNegativeMatch
    const groupedTags = _.groupBy(tagCriteria, function (tag) {
      const tagId = tag.tagId || _.first(tag.tagIds);

      return tagId + '-' + tag.isNegativeMatch + '-' + tag.comparisonType;
    });

    _.forEach(groupedTags, function (groupedObject, tagId) {
      groupedTags[tagId] = _.uniq(_.map(groupedObject, 'value'));
    });

    return groupedTags;
  }

  function normalizeGeoAndBulkTagsInCriterias(criterias) {
    if (!criterias) {
      return;
    }
    const modifiedCriterias = angular.copy(criterias);
    _.forEach(modifiedCriterias, function (andObj) {
      if (getGeoTags(andObj.tagCriteria).length) {
        andObj.tagCriteria = _expandGeoTags(andObj.tagCriteria);
      }

      _modifyBulkTagInAndObj(andObj);
    });
    return modifiedCriterias;
  }

  function getDefaultTag(tag, isBulkTag, hasMultipleValues) {
    const tagResult = angular.copy(orFilter);
    if (tag) {
      tagResult.tagId = tag.tagId;
      tagResult.tagIds = tag.tagIds;
      tagResult.value = _joinGeoTag(tag);
      tagResult.valueList = _splitGeoTag(tag);
      tagResult.comparisonType = tag.comparisonType || tagResult.comparisonType;
      tagResult.isNegativeMatch = !!tag.isNegativeMatch;

      if (isBulkTag) {
        const comparisonType = hasMultipleValues ? comparisonTypeService.getMultipleBulkTagComparison() : comparisonTypeService.getDefaultBulkTagComparison();
        tagResult.comparisonTypeTemp = tag.comparisonTypeTemp || comparisonType;
      }

      if (tagResult.tagIds == null || tagResult.tagIds.length == 0) {
        delete tagResult.tagIds;
      }
    }

    return tagResult;
  }

  function groupGeoTags(criteria) {
    // Geo Tags with Equal criteria are saved as a bunch of "ORs" and Does Not Equal splited by commas
    // Here we group or split them by tagId, criteria and negative values to build a list to be used in the multi-select
    _.forEach(criteria, function (andObj) {
      const geoTags = getGeoTags(andObj.tagCriteria);
      if (geoTags.length) {
        const geoGroupedTags = groupByGeoTags(geoTags);
        _.forEach(geoGroupedTags, function (states, tagId) {
          const splitKey = tagId.split('-');
          const isNegativeMatch = splitKey[1] === 'true';
          if (!_isValidGeoComparisonType(splitKey[2], isNegativeMatch)) {
            return;
          }

          const firstIndex = _.findIndex(andObj.tagCriteria, function (t) {
            return (splitKey[0] === t.tagId || (t.tagIds && t.tagIds.indexOf(splitKey[0]) > -1)) && t.isNegativeMatch == (splitKey[1] === 'true') && t.comparisonType == splitKey[2];
          });

          _.remove(andObj.tagCriteria, function (t) {
            return (splitKey[0] === t.tagId || (t.tagIds && t.tagIds.indexOf(splitKey[0]) > -1)) && t.isNegativeMatch == (splitKey[1] === 'true') && t.comparisonType == splitKey[2];
          });

          andObj.tagCriteria.splice(firstIndex, 0, getDefaultTag({
            comparisonType: splitKey[2],
            tagId: splitKey[0],
            tagIds: splitKey[3] ? splitKey[3].split('|') : [],
            value: states,
            isNegativeMatch: isNegativeMatch
          }));
        });
      }
    });
  }

  function normalizeBulkTagForUI(criteria) {
    _.forEach(criteria, function (andObj) {
      if (andObj.tagCriteria && andObj.tagCriteria.length) {
        _.forEach(andObj.tagCriteria, function (orObj) {
          if (allowBulkTagsUpload(orObj.tagId)) {
            orObj.isBulkTag = true;
          }
        });
      }

      if (andObj.bulkCriteria) {
        andObj.tagCriteria = andObj.tagCriteria || [];

        const tag = getDefaultTag({
          tagId: andObj.bulkCriteria.tagId,
          tagIds: andObj.bulkCriteria.tagIds,
          isNegativeMatch: andObj.bulkCriteria.isNegativeMatch,
          value: andObj.bulkCriteria.value
        }, true, true);
        tag.Id = andObj.bulkCriteria.id || andObj.bulkCriteria.Id;
        tag.isBulkTag = true;
        tag.hasMultipleValues = true;

        andObj.tagCriteria.push(tag);

        delete andObj.bulkCriteria;
      }
    });
  }

  function normalizeGeoTagsInAndObj(andObj, andIndex) {
    // We transform the geotags with Equal criteria into individual ORs
    // Or join them with comma separator for Does Not Equal
    // The value holds what we save, the valueList holds the joined/split list
    const currentAndObj = andObj.tagCriteria[andIndex];
    if (andObj.tagCriteria.length > andIndex && angular.isArray(currentAndObj.valueList)) {
      if (currentAndObj.comparisonType == inComparisonType) {
        andObj.tagCriteria[andIndex].value = currentAndObj.valueList.join(',');
      } else {
        andObj.tagCriteria[andIndex].value = currentAndObj.valueList;
      }
    }

    const modifyAndObj = angular.copy(andObj);
    delete modifyAndObj.bulkCriteria;

    if (getGeoTags(modifyAndObj.tagCriteria).length) {
      modifyAndObj.tagCriteria = _expandGeoTags(modifyAndObj.tagCriteria);
    }

    _modifyBulkTagInAndObj(modifyAndObj);

    return modifyAndObj;
  }

  function filterByTagSource(tags, tagSource) {
    if (tagSource) {
      return tags.filter(function (tag) {
        return tag.tagSource.toLowerCase() === tagSource;
      });
    }
    return tags;
  }

  function isTagInArray(tags, tag) {
    return _.findIndex(tags, function (t) { return areEqualTags(tag, t); }) > -1;
  }

  function pushDedupTag(tags, tag) {
    if (!isTagInArray(tags, tag)) {
      tags.push(tag);
    }
  }

  function areEqualTags(tag1, tag2) {
    return tag1
      && tag2
      && tag1.tagType == tag2.tagType
      && tag1.tagName == tag2.tagName
      && tag1.tagSource == tag2.tagSource;
  }

  function _joinGeoTag(tag) {
    if (angular.isArray(tag.value)) {
      return tag.value.join(',');
    }
    return tag.value;
  }

  function _isValidGeoComparisonType(tagType, isNegativeMatch) {
    const validComparisonType = _.filter(comparisonTypeService.comparisonTypes, function (comparisonType) {
      return comparisonType.forGeoTags && comparisonType.key == tagType && comparisonType.isNegativeMatch == isNegativeMatch;
    });

    if (!validComparisonType || validComparisonType.length == 0) {
      return false;
    }
    return true;
  }

  function _splitGeoTag(tag) {
    if (angular.isArray(tag.value)) {
      if (tag.value.length > 0 && tag.value[0].split(',').length > 1) {
        return tag.value[0].split(',');
      }
      return tag.value;
    }
    else if (tag.value) {
      return tag.value.split(',');
    }
  }

  function _getStateValueProperty(tagId) {
    return _findStateGeoTag(tagId).stateValueProperty;
  }

  function _getProvinceValueProperty(tagId) {
    return _findProvinceGeoTag(tagId).provinceValueProperty;
  }

  function _allowBulkTagsUpload(tagId) {
    //Always allow bulk tags for all state tags
    return !isGeoTag(tagId);
  }

  function doesHaveMultipleValues(tagIds) {
    //Always allow bulk tags for all state tags
    return tagIds && tagIds.length > 1;
  }

  function _findStateGeoTag(tagId) {
    return _.find(geoTagsIds, { tagId: tagId });
  }

  function _findProvinceGeoTag(tagId) {
    return _.find(geoProvincesTagsIds, { tagId: tagId });
  }

  function filterByTagNames(tags, tagNames) {
    if (tagNames) {
      return tags.filter(function (tag) {
        return _.findIndex(tagNames, function (t) {
          return t.toLowerCase() === tag.tagName.toLowerCase();
        }) != -1;
      });
    }
    return tags;
  }

  function _modifyBulkTagInAndObj(modifyAndObj) {
    const bulkTagIndex = _.findIndex(modifyAndObj.tagCriteria, { isBulkTag: true, hasMultipleValues: true });

    if (bulkTagIndex > -1) {
      modifyAndObj.bulkCriteria = angular.copy(modifyAndObj.tagCriteria[bulkTagIndex]);
      _.remove(modifyAndObj.tagCriteria, { isBulkTag: true, hasMultipleValues: true });
    }
  }

  function _expandGeoTags(tagCriteria, searchFrom) {
    const findIndex = _.findIndex(tagCriteria, function (tag) {
      return isGeoTag(tag.tagId, tag.tagIds) && !isOldProvinceTag(tag);
    }, searchFrom || 0);
    if (findIndex > -1) {
      const tagCriteriaCopy = angular.copy(tagCriteria);
      const expandedTags = _getGeoCriterias(tagCriteria[findIndex]);
      tagCriteriaCopy.splice.apply(tagCriteriaCopy, [findIndex, 1].concat(expandedTags));
      return _expandGeoTags(tagCriteriaCopy, findIndex + expandedTags.length);
    } else {
      return tagCriteria;
    }
  }

  function _getGeoCriterias(tag) {
    const tags = [];
    if (tag.valueList && tag.comparisonType == 'IN') {
      tags.push(getDefaultTag({
        tagId: tag.tagId,
        tagIds: tag.tagIds,
        value: tag.valueList,
        comparisonType: tag.comparisonType,
        isNegativeMatch: tag.isNegativeMatch
      }));
    }
    else {
      _.forEach(tag.valueList, function (state) {
        tags.push(getDefaultTag({
          tagId: tag.tagId,
          tagIds: tag.tagIds,
          value: state,
          comparisonType: tag.comparisonType,
          isNegativeMatch: tag.isNegativeMatch
        }));
      });
    }
    return tags;
  }

  function _getTagsWithCategory(tags) {
    if (Array.isArray(tags) && tags.length > 0) {
      const sortedTags = _.sortBy(tags, ['tagType']);
      let tagType = sortedTags[sortedTags.length - 1].tagType;
      for (let i = sortedTags.length - 1; i >= 0; i--) {
        if (sortedTags[i].tagType != tagType) {
          sortedTags.splice(i + 1, 0, {
            tagType: tagType
          });
          tagType = sortedTags[i].tagType;
        }
        if (i == 0) {
          sortedTags.splice(0, 0, {
            tagType: tagType
          });
        }
        return sortedTags;
      }
    }
    return [];
  }
}
